(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trendspot-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  const select = event.target;
  if (!(select instanceof HTMLSelectElement) || !select.matches('.ts-buy-form select[name="id"]')) return;
  const product = select.closest('.ts-product');
  const option = select.selectedOptions[0];
  if (!product || !option) return;
  const image = product.querySelector('.ts-variant-image');
  if (image && option.dataset.image) {
    image.removeAttribute('srcset');
    image.src = option.dataset.image;
    image.alt = option.dataset.imageAlt || '';
  }
  const swatch = product.querySelector('.ts-swatch');
  if (swatch) swatch.style.backgroundColor = option.dataset.swatch || '';
  const price = product.querySelector('.ts-price');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});

  } catch(e) { console.error(e); }
})();
})();
